{
  "version": 1,
  "asset_id": "a54dd872-212c-47ae-801b-9da3c72d0312",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a54dd872-212c-47ae-801b-9da3c72d0312/band-dilated-esophagus-annotated-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a54dd872-212c-47ae-801b-9da3c72d0312/band-dilated-esophagus-annotated-800.jpg",
  "original_filename": "band-dilated-esophagus-annotated-800.jpg",
  "size": 42564,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T01:39:59Z"
}
